import * as React from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var IconArrowUp = function IconArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.4716 8.52838C13.7645 8.82127 14.2394 8.82127 14.5323 8.52838C14.8252 8.23548 14.8252 7.76061 14.5323 7.46772L10.5323 3.46772C10.3916 3.32706 10.2009 3.24805 10.002 3.24805C9.80304 3.24805 9.61182 3.32752 9.47117 3.46817L5.47162 7.46772C5.17873 7.76061 5.17873 8.23548 5.47162 8.52838C5.76452 8.82127 6.23939 8.82127 6.53228 8.52838L9.25207 5.80859L9.25208 15.9985C9.25208 16.4127 9.58786 16.7485 10.0021 16.7485C10.4163 16.7485 10.7521 16.4127 10.7521 15.9985L10.7521 5.80883L13.4716 8.52838Z",
    fill: "black"
  }));
};

export { IconArrowUp };